// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selWidth[data-v-0ae01bf3] {\n  width: 460px !important;\n}\n", ""]);
// Exports
module.exports = exports;
